module.exports = {
      id: "account-rapport-usage",
      viewBox: "0 0 17.6 21.6",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#account-rapport-usage",
      toString: function () {
        return this.url;
      }
    }